<div class="background-image">
  <div class="container">
    <div class="jumbotron jumbotron-fluid">
      <div class="d-flex flex-wrap">
        <div>
          <h1 class="display-4">Universidad Abierta Interamericana</h1>
          <p class="lead">Repositorio Digital Institucional</p>
		  <p class="display-5">
		  El <b>Repositorio Digital Institucional</b> centraliza la colección digital de la producción científico-tecnológica institucional que permite reunir, almacenar, preservar y difundir objetos digitales. El Sistema de Gestión SIGUE también se articula con el Repositorio Digital de la UAI automatizando la carga de las tesis de grado y posgrado para su posterior publicación. El repositorio fue diseñando en su arquitectura de software bajo normas estandarizadas de Open Access y Open Data para su fácil relevamiento por las cosechadoras de datos.
		  </p>
        </div>
      </div>
      
    </div>
  </div>
  
</div>
